import {
  FILTERS_ADDITIONAL_OPTIONS,
  FILTERS_ADDITIONAL_OPTIONS_NAMES,
  FILTERS_PARAMS_TYPES,
} from '@/common/constants/filtersFields'

const applyDefaultFilter = (state, payload) => {
  state.filtersParams[payload.name] = FILTERS_PARAMS_TYPES[payload.type]
  state.needFetchCreatives = true
}

export const setCurrentLayoutType = (state, { payload }) => {
  state.currentLayoutType = payload
}

export const setIsLoadingItems = (state, { payload }) => {
  state.isLoadingItems = payload
}

export const setIsInfiniteScroll = (state, { payload }) => {
  state.isInfiniteScroll = payload
}

export const updatePaginationParams = (state, { payload }) => {
  state.pagination.page = payload
  state.paginationParams.page = payload
}

export const setPagesMap = (state, { payload }) => {
  state.pagesMap = payload
}

export const setItems = (state, { payload }) => {
  state.items = payload
}

export const setSelectedItem = (state, { payload }) => {
  state.selectedItem = payload
}

export const updateFiltersParams = (state, { payload }) => {
  const { field, value, isUpdatedStructure } = payload
  state.needFetchCreatives = true

  if (FILTERS_ADDITIONAL_OPTIONS_NAMES[field]) {
    state.filtersParams[field] = value
    return state
  }

  if (isUpdatedStructure) {
    const data = state.filtersParams[field]

    state.filtersParams[field] = {
      ...data,
      ...value,
    }

    return state
  }

  state.filtersParams[field].data = value
}

export const setFiltersParams = (state, { payload }) => {
  if (!state.filtersParams) return

  Object.keys(payload ?? {}).forEach((key) => {
    const current = state.filtersParams[key]
    const updatedValue = payload[key]

    if (FILTERS_ADDITIONAL_OPTIONS[key]) {
      state.filtersParams[key] = updatedValue
      return
    }

    if (current) {
      state.filtersParams[key] = {
        ...current,
        ...updatedValue,
      }
    }
  })
}

export const resetToDefaultFilter = (state, { payload }) => {
  applyDefaultFilter(state, payload)
}

export const resetFilterToDefaultByInputs = (state, { payload }) => {
  payload.forEach((filter) => {
    if (!filter.pinned) {
      applyDefaultFilter(state, filter)
    }
  })
}

export const resetAllFilters = (state) => {
  if (state.filtersParams) {
    const correctConfig = state.filtersConfigMap ?? state.filtersConfig

    Object.keys(state.filtersParams).forEach((key) => {
      if (FILTERS_ADDITIONAL_OPTIONS_NAMES[key]) {
        state.filtersParams[key] = FILTERS_ADDITIONAL_OPTIONS[key]
        return
      }

      state.filtersParams[key] = FILTERS_PARAMS_TYPES[correctConfig[key].type]
    })
  }
}
